<template>
  <n-space vertical class="swiper-no-swiping">
    <n-slider v-model:value="value" range step="mark" :min="$store.state.costFixMin" :max="$store.state.costFixMax"
      :marks="marks" :tooltip="false" />
  </n-space>
  <!--costActive-->
  <!-- <n-space style="margin-top: 1rem; cursor: pointer">
    <n-switch v-model:value="costActive" @update:value="activateCostSlider" />
    <span style="cursor: pointer" v-on:click="activateCostSlider">
      {{
        $store.state.appTexts.ageactive[$store.state.user.countryCode]
      }}
    </span>
  </n-space>-->
</template>

<script>
/* eslint-disable */
import { defineComponent, ref } from "vue";
import UpdateActivitiesService from "@/services/UpdateActivitiesService.js";
import { useStore } from "vuex";
import { computed } from "vue";
import ClickFilterService from "@/services/ClickFilterService.js";

export default defineComponent({
  data() {
    return { show: false };
  },
  props: {
    deactivateCostFilter: Boolean,
  },
  setup() {
    const store = useStore();
    var pig = (
      <svg height="18px" viewBox="0 0 512 512" width="18px" fill="#2c3e50">
        <path d="M232.627,268.19c-2.212,1.761-3.93,3.961-5.198,6.585c-1.248,2.602-1.889,5.671-1.889,9.217  c0,5.555,1.776,9.849,5.309,12.896c3.535,3.02,9.354,5.48,17.441,7.324v-41.201c-2.87,0-5.668,0.42-8.352,1.265  C237.256,265.121,234.798,266.416,232.627,268.19 M284.307,353.365c-4.14-3.277-11.15-6.264-21.091-8.954v48.507  c3.024-0.316,6.198-1.041,9.45-2.135c3.307-1.1,6.234-2.647,8.882-4.682c2.587-2.006,4.722-4.505,6.427-7.446  c1.679-2.953,2.527-6.45,2.527-10.49C290.502,361.599,288.423,356.655,284.307,353.365 M335.211,161.639l0.036,0.031  c-0.113-0.125-0.189-0.246-0.303-0.369c-4.839-6.736-9.676-13.212-14.397-19.37c-6.236-10.43-9.523-23.12-1.892-41.427v-0.012  l26.324-62.988l-41.325-18.834L307.884,0H204.072l5.442,23.789l-42.511,13.716l26.304,62.988v0.012  c13.018,31.139-5.615,46.01-16.556,61.166C122.598,236.552,61.98,343.759,61.98,408.389c0,107.167,83.237,103.598,194.02,103.598  c110.768,0,194.021,3.569,194.021-103.598C450.021,343.747,389.346,236.541,335.211,161.639 M229.926,109.053h52.982v33.434h-52.982  V109.053z M323.61,383.695c-1.854,5.665-5.178,11.176-9.979,16.559c-4.799,5.405-11.259,10.204-19.351,14.421  c-8.087,4.212-18.44,6.732-31.064,7.574v21.497H248.29v-21.497c-18.877-1.342-33.634-7.159-44.234-17.447  c-10.639-10.277-16.781-25.349-18.46-45.248h35.639c-0.155,9.631,2.376,17.194,7.592,22.763c5.215,5.555,11.719,9.094,19.464,10.602  v-52.81c-0.849-0.35-1.982-0.725-3.419-1.144c-1.437-0.425-3.004-0.804-4.667-1.138c-6.234-1.685-12.394-3.675-18.442-5.935  c-6.085-2.271-11.526-5.319-16.323-9.098c-4.802-3.79-8.637-8.527-11.493-14.152c-2.87-5.652-4.307-12.683-4.307-21.111  c0-8.593,1.646-16.179,4.95-22.747c3.287-6.578,7.598-12.094,13.001-16.564c5.405-4.459,11.641-7.907,18.707-10.36  c7.087-2.44,14.398-3.913,21.994-4.424v-19.463h14.926v19.463c7.562,0.845,14.685,2.494,21.354,4.93  c6.632,2.458,12.488,5.811,17.571,10.112c5.024,4.292,9.183,9.655,12.358,16.038c3.212,6.439,5.064,14.01,5.555,22.754h-35.882  c-0.171-6.726-2.288-12.47-6.313-17.174c-4.063-4.726-8.938-7.086-14.645-7.086v44.739c2.005,0.517,4.067,1.021,6.198,1.517  c2.079,0.511,4.327,1.084,6.688,1.776c12.471,3.36,22.074,7.537,28.796,12.509c6.729,4.968,11.717,10.146,14.929,15.54  c3.194,5.411,5.083,10.802,5.688,16.184c0.584,5.396,0.889,10.184,0.889,14.416C326.406,373.377,325.46,378.064,323.61,383.695" />
      </svg>
    );
    if (store.state.costEmptyList.includes(0)) {
      var n0 = 0;
      var v0 = pig;
    }
    if (store.state.costEmptyList.includes(1)) {
      var n1 = 1;
      var v1 = "0";
    }
    if (store.state.costEmptyList.includes(2)) {
      var n2 = 2;
      var v2 = "€";
    }
    if (store.state.costEmptyList.includes(3)) {
      var n3 = 3;
      var v3 = "€€";
    }
    if (store.state.costEmptyList.includes(4)) {
      var n4 = 4;
      var v4 = "€€€";
    }

    return {
      value: ref([
        store.state.costSliderValueMin,
        store.state.costSliderValueMax,
      ]),
      costActive: ref(computed(() => store.state.costActive)),

      marks: {
        [n0]: v0,
        [n1]: v1,
        [n2]: v2,
        [n3]: v3,
        [n4]: v4,
      },
    };
  },
  watch: {
    value() {
      console.log("CostSlider value changed");
      var that = this
      // setTimeout(function () {
      // }, 250);
      this.updateCostSlider();
    },
    deactivateCostFilter() {
      console.log("deactivateCostFilter")
      this.$store.state.costActive = false;
      this.$store.state.filters.cost.forEach(function (filterObject) {
        filterObject.selected = false;
        filterObject.lastAnswerWithValues = false
      })
      delete this.$store.state.clickedAnswers.cost
      UpdateActivitiesService.updateActivities();
    }
  },
  methods: {
    // activateCostSlider: function () {
    //   this.$store.state.costActive = !this.$store.state.costActive;
    //   this.updateCostSlider();
    // },
    updateCostSlider: function () {
      let that = this;
      let thats = this.$store;
      let costSliderValueMin = this.value[0];
      let costSliderValueMax = this.value[1];

      var fcost = this.$store.state.filters.cost;

      setTimeout(function () {
        that.$store.state.costActive = true;

        if (
          that.value[0] == costSliderValueMin &&
          that.value[1] == costSliderValueMax
        ) {
          // console.log( "costSliderValueMin = " + Math.min.apply(null, that.value) );
          thats.state.costSliderValueMin = Math.min.apply(null, that.value);
          costSliderValueMin = Math.min.apply(null, that.value);

          // console.log( "costSliderValueMax = " + Math.max.apply(null, that.value) );
          thats.state.costSliderValueMax = Math.max.apply(null, that.value);
          costSliderValueMax = Math.max.apply(null, that.value);

          thats.state.clickedAnswers["cost"] = {};
          switch (thats.state.costSliderValueMax) {
            case 0:
              thats.state.clickedAnswers["cost"][fcost[0].filterkey] = fcost[0];
              thats.state.filters.cost[0].selected = true;
              thats.state.filters.cost[1].selected = false;
              thats.state.filters.cost[2].selected = false;
              thats.state.filters.cost[3].selected = false;
              thats.state.filters.cost[4].selected = false;
              // console.log("000000000000000000000000000000");
              // console.log(thats.state.filters.cost[0].selected);
              break;
            case 1:
              if (costSliderValueMin == 0) {
                thats.state.clickedAnswers["cost"][fcost[0].filterkey] =
                  fcost[0];
              }
              thats.state.clickedAnswers["cost"][fcost[1].filterkey] = fcost[1];
              thats.state.filters.cost[0].selected = costSliderValueMin == 0;
              thats.state.filters.cost[1].selected = true;
              thats.state.filters.cost[2].selected = false;
              thats.state.filters.cost[3].selected = false;
              thats.state.filters.cost[4].selected = false;
              // console.log("1111111111111111111111111111111");
              // console.log(thats.state.filters.cost[1].selected);
              break;

            case 2:
              if (costSliderValueMin == 0) {
                thats.state.clickedAnswers["cost"][fcost[0].filterkey] =
                  fcost[0];
                thats.state.clickedAnswers["cost"][fcost[1].filterkey] =
                  fcost[1];
              }
              if (costSliderValueMin == 1) {
                thats.state.clickedAnswers["cost"][fcost[1].filterkey] =
                  fcost[1];
              }
              thats.state.clickedAnswers["cost"][fcost[2].filterkey] = fcost[2];

              thats.state.filters.cost[0].selected = costSliderValueMin == 0;
              thats.state.filters.cost[1].selected =
                costSliderValueMin == 0 || costSliderValueMin == 1;
              thats.state.filters.cost[2].selected = true;
              thats.state.filters.cost[3].selected = false;
              thats.state.filters.cost[4].selected = false;
              // console.log("2222222222222222222222222222");
              // console.log(thats.state.filters.cost[2].selected);
              break;

            case 3:
              if (costSliderValueMin == 0) {
                thats.state.clickedAnswers["cost"][fcost[0].filterkey] =
                  fcost[0];
                thats.state.clickedAnswers["cost"][fcost[1].filterkey] =
                  fcost[1];
                thats.state.clickedAnswers["cost"][fcost[2].filterkey] =
                  fcost[2];
              }
              if (costSliderValueMin == 1) {
                thats.state.clickedAnswers["cost"][fcost[1].filterkey] =
                  fcost[1];
                thats.state.clickedAnswers["cost"][fcost[2].filterkey] =
                  fcost[2];
              }
              if (costSliderValueMin == 2) {
                thats.state.clickedAnswers["cost"][fcost[2].filterkey] =
                  fcost[2];
              }
              thats.state.clickedAnswers["cost"][fcost[3].filterkey] = fcost[3];

              thats.state.filters.cost[0].selected = costSliderValueMin == 0;
              thats.state.filters.cost[1].selected =
                costSliderValueMin == 0 || costSliderValueMin == 1;
              thats.state.filters.cost[2].selected =
                costSliderValueMin == 0 ||
                costSliderValueMin == 1 ||
                costSliderValueMin == 2;
              thats.state.filters.cost[3].selected = true;
              thats.state.filters.cost[4].selected = false;
              // console.log("33333333333333333333333333");
              // console.log(thats.state.filters.cost[3].selected);
              break;

            case 4:
              if (costSliderValueMin == 0) {
                thats.state.clickedAnswers["cost"][fcost[0].filterkey] =
                  fcost[0];
                thats.state.clickedAnswers["cost"][fcost[1].filterkey] =
                  fcost[1];
                thats.state.clickedAnswers["cost"][fcost[2].filterkey] =
                  fcost[2];
                thats.state.clickedAnswers["cost"][fcost[3].filterkey] =
                  fcost[3];
              }
              if (costSliderValueMin == 1) {
                thats.state.clickedAnswers["cost"][fcost[1].filterkey] =
                  fcost[1];
                thats.state.clickedAnswers["cost"][fcost[2].filterkey] =
                  fcost[2];
                thats.state.clickedAnswers["cost"][fcost[3].filterkey] =
                  fcost[3];
              }
              if (costSliderValueMin == 2) {
                thats.state.clickedAnswers["cost"][fcost[2].filterkey] =
                  fcost[2];
                thats.state.clickedAnswers["cost"][fcost[3].filterkey] =
                  fcost[3];
              }
              if (costSliderValueMin == 3) {
                thats.state.clickedAnswers["cost"][fcost[3].filterkey] =
                  fcost[3];
              }
              thats.state.clickedAnswers["cost"][fcost[4].filterkey] = fcost[4];

              thats.state.filters.cost[0].selected = costSliderValueMin == 0;
              thats.state.filters.cost[1].selected =
                costSliderValueMin == 0 || costSliderValueMin == 1;
              thats.state.filters.cost[2].selected =
                costSliderValueMin == 0 ||
                costSliderValueMin == 1 ||
                costSliderValueMin == 2;
              thats.state.filters.cost[3].selected =
                costSliderValueMin == 0 ||
                costSliderValueMin == 1 ||
                costSliderValueMin == 2 ||
                costSliderValueMin == 3;
              thats.state.filters.cost[4].selected = true;
              // console.log("44444444444444444444444444");
              // console.log(thats.state.filters.cost[4].selected);
              break;
          }
          if (!thats.state.costActive) {
            delete thats.state.clickedAnswers["cost"];
            thats.state.filters.cost[0].selected = false;
            thats.state.filters.cost[1].selected = false;
            thats.state.filters.cost[2].selected = false;
            thats.state.filters.cost[3].selected = false;
            thats.state.filters.cost[4].selected = false;
          }

          // console.log(thats.state.filters.cost);
          // console.log(thats.state.clickedAnswers);

          UpdateActivitiesService.updateActivities();

          ClickFilterService.clickFilter("onlycheckcountzeroandresethistory");
        }
      }, 200);
    },
    bow: function () {
      // console.log("BBBBBBBBBBBBBBBB");
    },
  },
});
</script>
<style scoped>
.n-slider {
  --n-dot-border: none !important;
  --n-dot-border-active: none !important;
  --n-fill-color-hover: #007bff !important;
  --n-fill-color: #007bff !important;
  touch-action: pan-x;
}

.n-switch.n-switch--active {
  --n-rail-color-active: #007bff !important;
  --n-box-shadow-focus: 0 0 0 2px transparent !important;
  --n-loading-color: #007bff !important;
  /*background-color: #6610f280 !important;*/
  --n-rail-color: #007bff !important;
}

.n-switch {
  --n-rail-color-active: #007bff !important;
  --n-box-shadow-focus: 0 0 0 2px transparent !important;
  --n-loading-color: #007bff !important;
  /*background-color: #6610f280 !important;*/
  --n-rail-color: #007bff80 !important;
}
</style>
<style>
.v-binder-follower-container {
  z-index: 1 !important;
}

.n-slider-dot {
  height: 0rem !important;
}

.n-slider-mark {
  width: 2rem;
  position: static;
}
</style>